export default __webpack_public_path__ + "static/media/pencil.32817fa3.svg";